import Vue from 'vue'
import VueTelInput from 'vue-tel-input'
import '../assets/scss/components/vue-tel-input.scss'

Vue.component('i-phone-input', VueTelInput)
